import {
  deleteLeaveConfig,
  getLeaveConfigDetail,
  getLeaveConfigList,
  saveLeaveConfig,
} from '../services';

export default {
  namespace: 'holidaySetting',
  state: {},
  effects: {
    *getLeaveConfigList({ payload }, { call }) {
      const res = yield call(getLeaveConfigList, payload);
      return res;
    },

    *saveLeaveConfig({ payload }, { call }) {
      const res = yield call(saveLeaveConfig, payload);
      return res;
    },

    *getLeaveConfigDetail({ payload }, { call }) {
      const res = yield call(getLeaveConfigDetail, payload);
      return res;
    },

    *deleteLeaveConfig({ payload }, { call }) {
      const res = yield call(deleteLeaveConfig, payload);
      return res;
    },
  },
  reducers: {
    update(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
